const RegurgitationFields = [
  "Tricuspid Regurgitation",
  "Mitral Regurgitation",
  "Aortic/IVOT Regurgitation",
  "Pulmonic Regurgitation",
];

export default RegurgitationFields;
